<div class="body-savings">
  <span *ngIf="!totalDiscount">
    <ng-container
      *ngTemplateOutlet="totalDiscountTemplate; context: { totalDiscount: 0, label: 'pt.edp.edponline.widget.benefits.partners.save.title' }">
    </ng-container>
  </span>
  <span *ngIf="totalDiscount">
    <ng-container
      *ngTemplateOutlet="totalDiscountTemplate; context: { totalDiscount: totalDiscount, label: 'pt.edp.edponline.widget.benefits.already.saved.title'}">
    </ng-container>
  </span>
  
  <div class="d-flex justify-content-between mt-4" *ngIf="showAllMoneySaved">
    <span class="d-block savings-money-label">
      <div class="savings-money">{{ userMoneySaved }} €</div>
      <div class="savings-description">{{'pt.edp.edponline.widget.benefits.consumption.locations.description' | translate }}</div>
    </span>
    <span class="d-block savings-money-label">
      <div class="savings-money">{{ thirdMoneySaved }} €</div>
      <div class="savings-description" *ngIf="onlyThird"> {{'pt.edp.edponline.benefits.consumption.locations.of.third' | translate}}  {{ thirdName }}</div>
      <div class="savings-description" *ngIf="consumptionLocations"> {{'pt.edp.edponline.benefits.consumption.locations.of.several.third' | translate: {'consumptionLocations': consumptionLocations} }}</div>
    </span>
  </div>
  
  
  <div class="d-flex justify-content-between mt-4" *ngIf="showThird">
    <span class="d-block savings-money-label">
      <div class="savings-description" *ngIf="onlyThird"> {{'pt.edp.edponline.benefits.consumption.locations.of.third' | translate}}  {{ thirdName }}</div>
      <div class="savings-description" *ngIf="consumptionLocations"> {{'pt.edp.edponline.benefits.consumption.locations.of.several.third' | translate: {'consumptionLocations': consumptionLocations} }}</div>
    </span>
  </div>
</div>

<!-- Shared ngTemplates & note let-[variable] to read context object into scope -->
<ng-template
  #totalDiscountTemplate
  let-totalDiscount="totalDiscount"
  let-label="label">
  <div class="d-flex justify-content-between">
    <span class="d-block">
      <div class="savings-title" [innerHTML]="label | translate"></div>
      <div class="savings-discount" [innerHTML]="totalDiscount | edpDecimalSplit"></div>
    </span>
    <span class="icon">
      <i class="icon-edponline-EDP_Online_02 icon-2x"  aria-hidden="true"></i>
    </span>
  </div>
</ng-template>